(function($) {
	'use strict';

	$.fn.extend({


		/* Csrf token */


		addToken: function(object) {
			if (object instanceof Array) {
				object.push({
					name: 'csrf_token',
					value: $('html head meta[name="csrf_token"]').prop('content')
				});
			} else {
				object.csrf_token = $('html head meta[name="csrf_token"]').prop('content');
			}
			return object;
		},


		/* Triangles */

		sameHeightSquareInside: function(elementClass) {
			if (!$(this).length) { return this; }
			elementClass = elementClass || '';

			$(this).on('updateCss', function() {
				$(this).each(function() {
					var s = $(this).outerHeight();
					var $triangle = $(this).find('.' + elementClass);
					if (!$triangle.length) {
						$triangle = $('<div class="' + elementClass + '"/>');
						$(this).append($triangle);
					}
					$triangle.css({ width:s, height:s });
				});
			}).trigger('updateCss');

			return this;
		},


		/* Length select */

		lengthPicker: function(opts) {
			if (!$(this).length) { return this; }
			$(this).each(function() {

				var $this = $(this);
                
				var min = .5;
				var max = 7;
				var step = .5;

				$this.attr({
					value: $this.val(),
					min: min,
					max: max,
					step: step
				});
                
                $this.off('newPrice');
                
                $this.on('newPrice', function (e, newPrice) {
                    var newPriceString = newPrice.toFixed(2);
                    $('.sug-price-calc').text(newPriceString);
                    $('#sug-price-hidden').val(newPriceString);
                    if ($('.user-price-calc').hasClass('multistep-price'))
                    {
                        $('.user-price-slider').val(parseInt(newPriceString));
                        $('.user-price-calc').text(parseInt(newPriceString).toFixed(2));
                    }

                });

				if (opts === 'destroy') {
					$this
						.off('input change newPrice')
						.unwrap('.length-picker');
				}
				else {
					opts = opts || {};
					$this.wrap('<div class="length-picker"></div>');
                    var $timeCalc = $('.time-calc', $this.parents('.selectduration:first'));
					$this.wrap('<div class="duration-input-wrapper"></div>');
					var calcPrice = function() {
						var price;
                        price = ($this.val() * 40 - 2)/2;
						$this.trigger('newPrice', price);
					};

					$(this)
						.on('input change', function() {
                            var minutes = Math.floor(60 * parseFloat($this.val()) / 60);
                            var seconds = parseFloat(60 * $this.val()) % 60;
                            var secondsString = seconds.toString().length < 2 ? "0" + seconds : seconds;
                            $timeCalc.text(minutes + ':' + secondsString);
							calcPrice();
						}).trigger('change');
				}

			});


			return this;
		},

        lengthPickerUserPrice: function (opts) {
            if (!$(this).length) {
                return this;
            }
            $(this).each(function () {
                var $this = $(this);

                //var durationEl = $('[name="duration"]');
                //
                //var calcPriceByDuration = function(duration) {
                //    return duration * 40 - 2;
                //};
                //
                //var min = calcPriceByDuration(durationEl.attr('min'));
                //var max = calcPriceByDuration(durationEl.attr('max'));
                
                var min = 0;
                var max = 150;
                if ($('.user-price-calc').hasClass('multistep-price'))
                {
                    max = 75;
                }
                var step = 1;

                $this.attr({
                    min  : min,
                    max  : max,
                    step : step
                });

                $this.off('newPrice');

                $this.on('newPrice', function (e, newPrice) {
                    var newPriceString = newPrice.toFixed(2);
                    $('.user-price-calc').text(newPriceString);
                });

                if (opts === 'destroy') {
                    $this
                        .off('input change newPrice')
                        .unwrap('.length-picker');
                }
                else {
                    opts = opts || {};

                    $(this)
                        .on('input change', function () {
                            var price = parseFloat($this.val());
                            $this.trigger('newPrice', price);
                        }).trigger('change');
                }

            });

            return this;
        },


		/* Scroll top / bottom */

		scrollToBottom: function(ms) {
			$(this).each(function() {
				var $el = $(this);
				$el.animate({
					scrollTop: this.scrollHeight - $el.outerHeight()
				}, ms || 250);
			});
			return this;
		},
		scrollToTop: function() {
			$(this).each(function() {
				$(this).animate({
					scrollTop: 0
				}, ms || 250);
			});
			return this;
		},


		/* Block element during loading */

		loading: function(method) {
			var overlay = $('<span class="loading"/>');
			overlay.on('click', function(e) {
				e.preventDefault();
				e.stopPropagation();
			});
			this.each(function() {
				var $this = $(this);
				switch (method) {
					case ('start'):
						if ($('.loading', $this).length) { return; }
						if($this.css('position') === 'static') {
							$this.css({ position: 'relative' });
						}
						$this.append(overlay.clone('true'));
						break;
					case ('error'):
						$this.find('.loading').addClass('error');
						setTimeout(function() {
							$this.find('.loading').remove();
						}, 2000);
						break;
					case ('finish'):
						$this.find('.loading').remove();
						break;
				}
			});
			return this;
		},


		/*
		* Init dropzone.js,
		* returns dropzone instance!)
		*/

		initOrderDropZone: function() {

			var $this = this;

			/* Init dropzone */

			var filePreviewTemplate = ''
				+ '<div class="dz-preview dz-file-preview ' + $this.prop('id') + '">'
				+ '	<div class="dz-details">'
				+ '		<strong class="dz-filename" data-dz-name></strong>'
				+ '		<span class="dz-size" data-dz-size></span>'
				+ '	</div>'
				+ '	<div class="dz-action"></div>'
				+ '	<div class="dz-success-mark"></div>'
				+ '	<div class="dz-progress-wrapper">'
				+ '		<div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>'
				+ '	</div>'
				+ '	<div class="dz-error-mark"></div>'
				+ '	<div class="dz-error-message"><span data-dz-errormessage></span></div>'
				+ '</div>';

			$this.dropzone({
				url: '/file/upload',
				method: 'post',
				maxFilesize: 5 * 1024 * 1024, // GB
				uploadMultiple: false,
				maxFiles: 10,
                acceptedFiles: 'video/*, image/*, .zip, .rar',
				init: function() {
					$this.find('.upload-info')
						.text('max ' + this.options.maxFiles + ' files up to ' + Math.round(this.options.maxFilesize / 1024 / 1024) + 'GB each')
				},
				previewsContainer: $this.find('.files-container').length ? $this.find('.files-container')[0] : $this.find('.upload-list ')[0],
				clickable: $this.find('.browse-button')[0],
				previewTemplate: filePreviewTemplate,
				addRemoveLinks: false
			});

			/* Dropzone events */

			var dz = Dropzone.forElement($this[0]);

			dz
				.on('addedfile', function(file) {
					$(window).trigger('resize'); // To fit fullpage.js cell

					/* Add remove button */
					var _this = this;
					var $removeButton = $(''
						+ '<button data-dz-remove class="btn delete">'
						+     '× Delete'
						+ '</button>');
					$removeButton.on('click', function (e) {
						e.preventDefault();
						e.stopPropagation();
						if (confirm('Are you sure want to remove file?')) {
							dz.removeFile(file);
						}
					});
					
					$(file.previewElement).find('.dz-action').append($removeButton);
					
					if ( $(dz.previewsContainer).css('position') != 'relative')
						$(dz.previewsContainer).addClass('upload-list-scroll');
				})

				

				.on('success', function(file, response) {
					if (response.csrf_token) {
						jQuery('html head meta[name=csrf_token]')
							.prop('content', response.csrf_token)
					}

					if (response.success === true) {
						$.each(response.data, function (key, value) {
							$(file.previewElement).data('file_id',value.id);
							file.file_id = value.id;
                            $this.find('.upload-area')
								.append($('<input id="uploaded_file_'+ value.id
									+'" type="hidden" name="files[]" value="'
									+ value.id + '" />'));
						});
					}
				})

				.on('removedfile', function(file) {
					var file_id = $(file.previewElement).data('file_id');
					api.fileDelete(file_id, function(err, data) {
						if (err) { return; }
						$('#uploaded_file_' + file_id).remove();
					});
				})

				.on("sending", function (file, xhr, formData) {
					formData.append("order_id", $this.find('.order-info-panel').data('order-id'));
				});
				
			return dz;
		}

	});


	

    $(function(){

        $('.user-price-slider').lengthPickerUserPrice();

        //mobile button

        $( ".mobile-button" ).on( "click", function() {
  			$(this).toggleClass( "active" );
  			$('.intro-top-menu-list').toggleClass( "show-menu" );
  		});

  		$( ".info-button" ).on( "click", function() {
  			$(this).toggleClass( "info-button-clicked" );
  		})

        // guarantees read more buttons

  		$('.guarantees-item').on("click", '.read-more', function() {
  			$(this).parents('.guarantees-item:first').find('.hidden').slideToggle("slow", "easeOutCubic");
  			$(this).toggleClass( "exp" );
		});		


  		// how it works more button+flip

  		$('.how-it-works-section').on("click", '.read-more', function() {
  			if ($(".flipper").hasClass('flip')) {
  				$(".flipper").removeClass('flip');
  				$(".how-it-works-section .read-more").removeClass('exp');
  				$(".flipper").height($(".front").outerHeight());
  			}
  			else {
	  			$(".flipper").addClass('flip');
	  			$(".how-it-works-section .read-more").addClass('exp');
	  			$('.flip').height($('.back').outerHeight());
  			}
		});

		$('.flipper').height($('.front').outerHeight());

		// contact us navigation

		$('.about .intro-text-sub a[href*=#]').click(function (e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: $('.contact-us-section').offset().top
            });
        });

        // let's start navigation

		$('.intro-call-to-action a[href*=#]').click(function (e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: $('.quick-contact-section > a').offset().top

            });
        });

		// contact us form reset button

        $('.contact-us-reset').click(function() {
  			$('.contact-us-content form input, textarea').val('');
		});

        if($('.remodal[data-remodal-id="show_message"]').length)
        {
            $.remodal.lookup[ $('.remodal[data-remodal-id="show_message"]').data('remodal') ].open();
        }
	 });


    $(function(){

        $(document).on('opened', '.remodal', function () {
            $(this).addClass('remodal-active');
        });

        $(document).on('closed', '.remodal', function (e) {
            $(this).removeClass('remodal-active');
        });

    });



    //****************************************//
    //                                        //
    //       Vimeo videos & SLick Slider      //
    //                                        //
    //****************************************//

    $(function(){

	// Change this to your username to load in your clips
	var vimeoUserName = 'user39248415';
	
	// Tell Vimeo what function to call
	var callback = 'showThumbs';
	
	// Set up the URLs
	var url = 'https://vimeo.com/api/v2/' + vimeoUserName + '/videos.json?callback=' + callback;
	
	// This function loads the data from Vimeo
	function init() {
		var js = document.createElement('script');
		js.setAttribute('type', 'text/javascript');
		js.setAttribute('src', url);
		document.getElementsByTagName('head').item(0).appendChild(js);
	}
	
	// This function goes through the clips and puts them on the page

	function showThumbs(videos) {
		var vimeo = document.getElementById('vimeo');
        if (!vimeo)
        {
            return false;
        }
		vimeo.innerHTML = '';
		
		for (var i = 0; i < videos.length; i++) {

			var videoTitle = document.createElement('h2');
				videoTitle.innerHTML = videos[i].title;

			var videoLength = document.createElement('h3');
				videoLength.setAttribute('class', 'length');
				videoLength.innerHTML = '<span>$</span>' + ( videos[i].duration * 0.325 ).toFixed(0);

			var videoSrcLength = document.createElement('h3');
				videoSrcLength.setAttribute('class', 'src-gb');
				videoSrcLength.innerHTML = '<span>made from</span>' + (( videos[i].duration * 10 ) / 60 * 300  ).toFixed(0) + 'MB';

			var info = document.createElement('div');
				info.setAttribute('class', 'info');
				info.appendChild(videoTitle);
				info.appendChild(videoLength);
				info.appendChild(videoSrcLength);

			var thumb = document.createElement('img');
				thumb.setAttribute('src', videos[i].thumbnail_large);
				thumb.setAttribute('alt', videos[i].tags);
				thumb.setAttribute('title', videos[i].title);
			
			var a = document.createElement('a');
				a.setAttribute('href', 'https://player.vimeo.com/video/'+videos[i].id+'?title='+videos[i].title+'&amp;byline=0&amp;portrait=0');
	            a.setAttribute('data-id', videos[i].id);
	            a.setAttribute('data-title', videos[i].title);
	            a.setAttribute('title', videos[i].description.replace(/<br \/>/gi, "\x0A"));
				a.setAttribute('class', 'fancybox-media');
				a.appendChild(info);
			
			var div = document.createElement('div');
				div.setAttribute('class', 'slide');
				div.appendChild(a);
				div.appendChild(thumb);
				vimeo.appendChild(div);
		}

		// Video slider 
		$('.demos-slider').slick({
			slidesToShow: 6,
			mobileFirst:true,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 2000,
			arrows:false,
			swipeToSlide:true,
			variableWidth:true,
			speed:200,
			lazyLoad:true,
			prevArrow:false,
			nextArrow:false,
			touchThreshold: 9
		});

        $('.slide.slick-slide a').click(function(){
            $('.slide.slick-slide a[data-active=1]').attr('data-active', 0);
            $(this).attr('data-active', 1);
        });

        //** Testi slider **//

	    $('.testimonials-list').slick({
			slidesToShow: 3,
			mobileFirst:true,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 2000,
			arrows:false,
			swipeToSlide:true,
			variableWidth:true,
			speed:200,
			lazyLoad:true,
			prevArrow:false,
			nextArrow:false,
			touchThreshold: 9
		});

        $(".fancybox-media").fancybox({
            padding: 0,
            width: 750,
            height: 500,
            autoScale: true,
            autoDimensions: false,
            type: 'iframe',
            fitToView : false,
            afterShow: function(){
              window.location.hash = 'video_' + $('.slide.slick-slide a[data-active=1]').attr('data-id');
                $('.fancybox-skin').before('<div class="vimeo-title">' + $('.slide.slick-slide a[data-active=1]').attr('data-title') + '</div>');
                $('.fancybox-skin').after('<div class="vimeo-control-panel">' + $(".video-control-container").html() + '</div>');
                var currentVideo = $('.slide.slick-slide a[data-active=1]').attr('data-id');
                $('.video-change.next').on('click', function(){
                    $('.slide.slick-slide:not(.slick-cloned) a[data-id="' + currentVideo + '"]').parent().next().find('a').click();
                });
                $('.video-change.prev').on('click', function(){
                    $('.slide.slick-slide:not(.slick-cloned) a[data-id="' + currentVideo + '"]').parent().prev().find('a').click();
                });
                $('.vimeo-control-panel .zig-button').on('click', function(){
                    $('.fancybox-close').click();
                });
                $('.slide.slick-slide a[data-active=1]').attr('data-active', 0);
              },
            afterClose: function() {
                window.location.hash = '';
                $('.vimeo-control-panel').remove();
                $('.video-change').off('click');
                $('.vimeo-control-panel .zig-button').off('click');
            }
        });

        if (window.location.hash.indexOf('video_') >=0)
        {
            var hash = window.location.hash.replace('#video_','');
            if ( $('.slide.slick-slide a[data-id='+hash+']').length )
            {
                $('.slide.slick-slide a[data-id='+hash+']').first().click();
            }
        }
	}
	
	// Call our init function when the page loads
	window.onload = init;

	window.showThumbs = showThumbs;

	});

	$(document).ready(function($) {

	// Counter

	var today = new Date();
	var dd = today.getDate();
	var mm = today.getMonth()+1;
	var yyyy = today.getFullYear().toString(); 

	if(dd<10) {
	    dd='0'+dd
	} 

	if(mm<10) {
	    mm='0'+mm
	} 

	today = yyyy+mm+dd;

	var todayRandom = Math.floor((Math.random() * 3) + 1);
	var projectsInProgress =  9 + todayRandom;
	var projectsCompleted = (today - 20160101) + 170 + todayRandom;
	var filesProcessed = projectsCompleted * ( 19 + todayRandom );



	$('.count.projects-completed span.counter').text(projectsCompleted);
	$('.count.projects-in-work span.counter').text(projectsInProgress);
	$('.count.gb span.counter').text(filesProcessed);

	$('.counter').counterUp({
	    delay: 30,
	    time: 2000
	});


	
	// Home menu active elem

	setActiveMenu();

	function setActiveMenu() {
		var path = window.location.pathname;
			path = path.replace(/\/$/, '');
			path = decodeURIComponent(path);


		$('.intro-top-menu a').each(function() {
			var href = $(this).attr('href');

	        if ( path.substring(0,href.length) === href ) {
	           $(this).addClass('active');
	        }
	    });
	}
	
});

}(jQuery));